const win = window as any;

// gtag引用必须在模板html里写死，否则谷歌会乱报检测不到
export const tryGtag: any = (...args: any[]) => {
  try {
    if (process.env.NODE_ENV === 'development') {
      console.log('gtag', ...args);
      return;
    }

    win.gtag(...args);
  } catch (error) {
    console.error('gtag error', error);
  }
};
